import { GoDotFill, GoPlus } from "react-icons/go";
import { Button } from "../../../../components/forms";
import { nodept } from "../../../../constant/import";
import useLeaveHook from "../../../../hooks/useLeaveHook";
import PositionItem from "../PositionItem";
import LeaveTypeITem from "./LeaveTypeITem";
import { Fragment, useEffect, useState } from "react";
import { FaCalendar } from "react-icons/fa";
import { BsPersonFillDash } from "react-icons/bs";
import { Menu, Transition } from "@headlessui/react";
import { CiEdit } from "react-icons/ci";
import { FiFileMinus } from "react-icons/fi";
import { IoMdEye, IoMdMore } from "react-icons/io";
import { MdCancel, MdDelete, MdOutlineCancel } from "react-icons/md";
import ContracctDetails from "../ContracctDetails";
import { LuUser } from "react-icons/lu";
import usePositionHook from "../../../../hooks/usePositionHook";
import useDepartmentHook from "../../../../hooks/useDepartmentHook";
import { useStateSetter } from "../../../../hooks/statehooks/UseStateSettersHook";

import Calendar from "react-calendar";
import useCalendarHook from "../../../../hooks/useCalendarHook";

export default ({ setshowaddleavemodal, leaves, refresh }: any) => {
  const EmptyList = () => (
    <div className=" mx-6 p-5 scale-[.75]   text-textbg flex flex-col justify-center rounded-xl items-center border border-gray-300 ">
      <img src={nodept} />
      <p className="font-bold">No Leave requests</p>
      <small>No leave requests yet</small>

      <Button
        width={200}
        disabled={false}
        text={
          <>
            <GoPlus size={15} className=" mx-1 inline" /> Add leave request
          </>
        }
        onBtnClick={() => {
          setshowaddleavemodal(true);
        }}
      />
    </div>
  );

  return (
    <div className="w-full">
      <div>
        {leaves.length > 0 ? (
          <div className="grid grid-cols-2 gap-2 bg-white">
            {leaves.map((g: any) => (
              <CalenderItem item={g} />
            ))}
          </div>
        ) : (
          <EmptyList />
        )}
      </div>
    </div>
  );
};

const CalenderItem = ({ item }: any) => {
  type ValuePiece = Date | null;
  var itemdate = new Date(item.startDate);
  type Value = ValuePiece | [ValuePiece, ValuePiece];
  const [value, onChange] = useState<Value>(itemdate);
  const [weekendsdays, setweekendsdays] = useState<string[]>([]);
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const { holidays, weekends } = useCalendarHook();

  useEffect(() => {
    let emptarr: any = [];
    weekends.map((kk: any) => {
      emptarr.push(kk.days);
      setweekendsdays(emptarr);
    });
    console.log(emptarr);
  }, [weekends]);

  return (
    <Calendar
      className={"scale-90"}
      tileContent={({ activeStartDate, date, view }) => (
        <div>
          {view === "month" &&
            date.getDate() === itemdate.getDate() &&
            date.getMonth() === itemdate.getMonth() &&
            date.getFullYear() === itemdate.getFullYear() && (
              <p className="relative ">
                {" "}
                <GoDotFill
                  size={15}
                  className={`${
                    item.status == "pending" || item.status == "rejected"
                      ? "text-[#F79009] mx-1"
                      : ""
                  }  ${
                    item.status == "approved" ? "text-green-400" : ""
                  } inline `}
                />
                <span className="    rounded px-1 block text-[10px] z-[100]  ">
                  {" "}
                  {item.status}
                </span>
              </p>
            )}{" "}
          {view === "month" &&
            weekendsdays.includes(daysOfWeek[date.getDay()]) && (
              <div className="text-[10px] text-primary">Weekend</div>
            )}
          {holidays.map((iy: any) => {
            return (
              <>
                {view === "month" &&
                  date.getDate() === new Date(iy.startDate).getDate() &&
                  date.getMonth() === new Date(iy.startDate).getMonth() && (
                    <p className="relative  text-green-700 ">
                      <GoDotFill size={15} className={` text-green-700 `} />
                      <span className="    rounded px-1 block text-[10px] z-[100]  ">
                        {iy.title}
                      </span>
                    </p>
                  )}
              </>
            );
          })}
        </div>
      )}
      onChange={onChange}
      value={[new Date(item.startDate), new Date(item.endDate)]}
    />
  );
};
